export const formatBusinessAddress = (location: any): string => {
  if (!location) return '';
  return [
    location.address,
    location.city?.name || location.city,
    location.state?.name || location.state,
    location.country?.name || location.country,
    location.zipCode,
  ]
    .filter(Boolean)
    .join(', ');
};
